export class GoogleWorkspaceSharedDriveEntireDriveOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "folderName",
            "baseName": "folderName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceSharedDriveEntireDriveOptions.attributeTypeMap;
    }
    constructor() {
    }
}
